<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <!-- Loader sadece ayarlar null ise veya auth gereken sayfada user null ise gösterilir -->
      <AppLoader 
        v-if="generalSettings === null || (authToken && !authUser.user && $route.meta.auth)" 
        key="loading" 
      />

      <div 
        v-else-if="generalSettings.general.maintenance.enabled === false" 
        class="app-page" 
        key="page"
      >
        <Chat />
        <Navbar />
        
        <template v-if="!isAdminRoute">
          <Sidebar/>
        </template>

        <ModalJackpot 
          v-if="isJackpotModalOpen" 
          @close="closeJackpotModal" 
        />
        
        <main 
          :class="{
            
            'main-sidebar-open': !isSidebarClosed,
            'main-sidebar-closed': isSidebarClosed,
            'main-chat-open': generalSidebarMobile === 'Chat',
            'main-chat-closed': generalSidebarMobile !== 'Chat'
          }"
          ref="mainContainer"
        >
          <router-view v-slot="{ Component }">
            <transition name="slide-fade" mode="out-in">
              <!-- 🔑 key eklendi -->
              <component :is="Component" :key="$route.fullPath" />
            </transition>
          </router-view>

     
          <template v-if="!isAdminRoute">
            <Footer />
          </template>
        </main>

        <BottomNavigation /> 
        <Modals />
        <Notifications />
      </div>

      <AppMaintenance v-else key="maintenance" />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppLoader from '@/components/AppLoader';
import AppMaintenance from '@/components/AppMaintenance';
import Navbar from '@/components/navbar/Navbar';
import Chat from '@/components/chat/Chat';
import Footer from '@/components/footer/Footer';
import Modals from '@/components/modals/Modals';
import Notifications from '@/components/notifications/Notifications';
import BottomNavigation from '@/components/BottomNavigation';
import Sidebar from '@/components/sidebar';
import ModalJackpot from '@/components/modals/ModalJackpot.vue';
import axios from "axios"

export default {
  components: {
    AppLoader,
    AppMaintenance,
    Navbar,
    Sidebar,
    ModalJackpot,
    Chat,
    Footer,
    Modals,
    Notifications,
    BottomNavigation,
  },
  data() {
    return {
      showTopGif: true,
      currentGifIndex: 0,
      topGifs: [
        { src: require('@/assets/img/bonus.gif'), route: '/rewards' },
        { src: require('@/assets/img/slot.gif'), route: '/rewards' },
        { src: require('@/assets/img/gift1.gif'), route: '/rewards' },
      ],
      gifInterval: null,
    };
  },
  methods: {
    ...mapActions(['socketConnectGeneral', 'toggleSidebar',  'closeJackpotModal']),
    startGifRotation() {
      this.gifInterval = setInterval(() => {
        this.currentGifIndex = (this.currentGifIndex + 1) % this.topGifs.length;
      }, 5000);
    },
    checkMobileLandscape() {
  const isMobileOrTablet = window.innerWidth <= 1024;
  const isLandscape = window.innerWidth > window.innerHeight;

  if (isMobileOrTablet && isLandscape) {
    document.body.classList.add('mobile-landscape');
  } else {
    document.body.classList.remove('mobile-landscape');
  }
}

  },

  // 🔥 TEK created — hepsi burada!
  async created() {
    this.socketConnectGeneral();

    if (this.authToken) {
      this.$store.dispatch("authGetUser");
    }

    this.startGifRotation();

    // === SITE SETTINGS FETCH ===
    const backend = process.env.VUE_APP_BACKEND_URL.replace(/\/$/, "");


    try {
      const res = await axios.get(`${backend}/settings/general`);
      const general = res.data;

      // — SITE TITLE —
      if (general.siteName) {
        document.title = general.siteName;
      }

      // — FAVICON —
      if (general.favicon) {
        const faviconUrl = backend + general.favicon;

        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = faviconUrl;
      }
    } catch (e) {
      console.error("Site ayarları yüklenemedi:", e);
    }
    this.checkMobileLandscape();
window.addEventListener('resize', this.checkMobileLandscape);
window.addEventListener('orientationchange', this.checkMobileLandscape);

  },

  computed: {
    ...mapGetters([
      'socketGeneral',
      'isJackpotModalOpen',
      'isSidebarClosed',
      'generalSettings',
      'authToken',
      'authUser',
      'generalSidebarMobile'
    ]),
    appGetRouteName() {
      return this.$route.name;
    },
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    },
  },

  beforeUnmount() {
    clearInterval(this.gifInterval);
    window.removeEventListener('resize', this.checkMobileLandscape);
window.removeEventListener('orientationchange', this.checkMobileLandscape);
document.body.classList.remove('mobile-landscape');

  }
}
</script>


<style>
/* === MAIN CONTENT === */
body .app-page main {
  position: fixed;
  top: 61px;
  right: 0;
  bottom: 0;
  height: calc(100% - 61px);
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  transition: all 0.3s ease;
  padding-left: 20px;
  padding-right: 20px;
  
}

/* Sidebar açık */
body .app-page main.main-sidebar-open {
  width: calc(100% - 16.375rem);
  right: 0;
}

/* Sidebar kapalı → %95 genişlik */
body .app-page main.main-sidebar-closed {
  width: 95%;
  right: 0;
}

/* Chat açıkken (sadece PC) → sağdan 325px daralt */
@media (min-width: 1176px) {
  body .app-page main.main-chat-open {
    width: calc(100% - 16.375rem - 325px);
    right: 325px;
  }
  body .app-page main.main-sidebar-closed.main-chat-open {
    width: calc(95% - 325px);
    right: 325px;
  }
body.mobile-landscape .app-page main {
  padding-left: 72px !important;
}
   
}

/* Mobilde genişlik tam kalacak */
@media (max-width: 1175px) {
  body .app-page main {
    width: 100% !important;
    right: 0 !important;
    height: calc(100% - 80px);
   
    
  }
  body .app-page main {
 
  padding: 0;
  
}
}

/* === Sabit GIF Alanı === */
.fixed-gif-area {
  position: fixed;
  bottom: 91px;
  right: 20px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;
}

.gif-box {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  overflow: hidden;
}

.gif-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gif-box .gif-close {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0,0,0,0.5);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  cursor: pointer;
  z-index: 2;
}
 

</style>
